// SubscribeButton.js
import { connect } from 'react-redux';

import { SUBSCRIPTION_CURRENCY } from '../RemoteConfigKeys.js';

import SubscribeButton from '../component/SubscribeButton.jsx';

import toggleSubscribeAndUnlockModal from '../action/toggleSubscribeAndUnlockModal.js';
import fetchDiamondPacks from '../action/fetchDiamondPacks.js';
import fetchUserSubscription from '../action/fetchUserSubscription.js';
import login from '../action/login.js';

import getListData from '../selector/getListData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { ProductType, SHOP_ID } from '../resource/shopConstants.js';

const mapStateToProps = (state, { userId }) => {
  const shopId = SHOP_ID.subscription;
  const defaultSubscriptionCurrency = getRemoteConfigData(
    state,
    SUBSCRIPTION_CURRENCY
  );
  return {
    shopId,
    meId: getMeData(state, 'id'),
    defaultSubscriptionCurrency,
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
    isSubscriptionFetched: getNetworkingData(
      state,
      ['fetch', 'user', userId, 'subscription'],
      'isFetched'
    ),
    isSubscriptionFetching: getNetworkingData(
      state,
      ['fetch', 'user', userId, 'subscription'],
      'isFetching'
    ),
    isSubscriptionProductFetched: getNetworkingData(
      state,
      [
        'shop',
        shopId,
        defaultSubscriptionCurrency,
        ProductType.SUBSCRIPTIONS,
        userId,
      ],
      'isFetched'
    ),
    isSubscriptionProductFetching: getNetworkingData(
      state,
      [
        'shop',
        shopId,
        defaultSubscriptionCurrency,
        ProductType.SUBSCRIPTIONS,
        userId,
      ],
      'isFetching'
    ),
    subscriptionProductIds: getListData(
      state,
      [
        'shop',
        shopId,
        defaultSubscriptionCurrency,
        ProductType.SUBSCRIPTIONS,
        userId,
      ],
      'itemIds'
    ),
    meSubscription: getUserData(state, userId, 'meSubscription'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDiamondPacks: ({ currency, shopId, type, productIds }) =>
      dispatch(fetchDiamondPacks({ currency, shopId, type, productIds })),
    fetchUserSubscription: ({ userId }) =>
      dispatch(fetchUserSubscription({ userId })),
    toggleSubscribeAndUnlockModal: ({
      userId,
      messageId,
      shopId,
      currency,
      isOpen,
    }) =>
      dispatch(
        toggleSubscribeAndUnlockModal({
          userId,
          messageId,
          shopId,
          currency,
          isOpen,
        })
      ),
    login: () => dispatch(login()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeButton);
